import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { CalendarOutlined, DownOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { merchantApi, pumkinAPI } from "@api";
import { ArrowLeftColor, IConClose, IconCheck3, ImageUploadIcon } from "@components";
import { PATH_HOME, PATH_WARRANTY_LIST, _10MB } from "@configs";
import { selectApp, selectAuth, selectMerchant, setLoading } from "@redux";
import UIStore from "@Rocket-Innovation/components/store/useUIStore";
import { formatMessage, useNotify } from "@utils";
import type { DatePickerProps } from "antd";
import { Button, Col, DatePicker, Input, Row, Select, Skeleton } from "antd";
import { useTranslation } from "react-i18next";
import useCache from "src/Store/useCache";
import styled from "styled-components";
import { SendIcon } from "../icon/Send";
import { PumpkinPopupDone } from "./PopupDone";
//@ts-ignore
const { Option } = Select;

export interface IinputValue {
    warrantyImage?: string;
    serialNumber?: string;
    productName?: string;
    productModel?: string;
    productCode?: string;
    channelId?: string;
    storeId?: string;
    channel?: string;
    store?: string;
    purchaseDate?: Date;
    status?: string;
    sellerId?: string;
    condition?: string;
    remark?: string;
    warrantyDurationMonth?: number;
    productImage?: string;
}
export const RegisterWarranty = () => {
    //page hook
    const history = useHistory();
    const dispatch = useDispatch();

    const { loading } = useSelector(selectApp);
    //page redux
    const { userInfo } = useSelector(selectAuth);
    const { themes } = useSelector(selectMerchant);
    const themeColor = themes?.themeColor!;
    const merchant = useSelector(selectMerchant);
    const { t } = useTranslation();
    const [receiptImg, setReceiptImg] = useState<any>("");
    const [imgFile, setImgFile] = useState<any>("");
    const { langSetting } = useSelector(selectApp);
    const { success, error, warning } = useNotify();
    const [openshowpopup, setOpenShowPopup] = useState<boolean>(false);
    const [tab, setTab] = useState<string>("upload");
    const [sellerCode, setSellerCode] = useState<string>("");
    const [isLine, setIsLine] = useState<boolean>(false);
    const [isLoading, setIsloading] = useState(true);
    const [showLoading, setShowLoading] = useState(false);
    const [inputValue, setInputValue] = useState<IinputValue>({ status: "PENDING" });
    const [channelList, setChannelList] = useState<any>([]);
    const [storeList, setStoreList] = useState<any>([]);
    const [openCodePopup, setOpenCodePopup] = useState<boolean>(false);
    const [openSNPopup, setOpenSNPopup] = useState<boolean>(false);
    const [dataVerify, setDataVerify] = useState<any>();
    const [selectedDetail, setSelectedDetail] = useState<"conditions" | "notes" | null>(null);
    const [isDetailTools, setDetailTools] = useState<boolean>(false);
    const [isShowPopupDone, setIsShowPopupDone] = useState<boolean>(false);

    //page state

    const getChannelList = async () => {
        try {
            const res = await pumkinAPI.getPumpkinChannel();
            if (res.data.value && Array.isArray(res.data.value)) {
                setChannelList(res.data.value);
            } else {
                setChannelList([]);
            }
        } catch (err) {
            console.log("getChannelList", err);
        }
    };
    const getStoreList = async (value: string) => {
        useCache.setState({ isLoading: true });
        try {
            const res = await pumkinAPI.getPumpkinStoreList({
                name: value,
            });
            if (res.data.value && Array.isArray(res.data.value)) {
                setStoreList(res.data.value);
                useCache.setState({ isLoading: false });
            } else {
                setStoreList([]);
                useCache.setState({ isLoading: false });
            }
            // if (res.data[0]?.channelList?.storeList) {
            //     setStoreList(res.data[0]?.channelList?.storeList);
            // }
        } catch (err: any) {
            setStoreList([]);
            error(formatMessage(err.response));
            console.log("getStoreList", err);
            useCache.setState({ isLoading: false });
        }
    };
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setInputValue((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    const onChannelChange = (value: string) => {
        setInputValue((prevState) => ({
            ...prevState,
            channel: value,
            store: "",
        }));
        getStoreList(value);
    };
    const onChangeDate: DatePickerProps["onChange"] = (dateString) => {
        setInputValue((prevState) => ({
            ...prevState,
            purchaseDate: new Date(dateString.toString()),
        }));
    };

    useEffect(() => {
        getChannelList();
    }, []);

    useEffect(() => {
        if (userInfo?.contact?.sellerId) {
            warning("Seller can not upload recript");
            history.push(PATH_HOME);
        }
    }, [userInfo]);

    useEffect(() => {
        setIsloading(true);
        if (merchant) {
            setIsloading(false);
        }
    });

    useEffect(() => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);

        window.addEventListener("resize", () => {
            vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
        });
    }, []);

    const inputRef = useRef();

    const changeImg = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files || e.target.files.length === 0) {
            setReceiptImg("");
            return;
        } else {
            const objectUrl = URL.createObjectURL(e.target.files[0]);
            setImgFile(e.target.files[0]);
            setReceiptImg(objectUrl);
        }
    };

    const uploadImage = async (formData: FormData) => {
        try {
            const res = await merchantApi.uploadImage(formData);
            return res.data.publicUrl;
        } catch (err: any) {
            // const data = err.response.data;
            // const mess = Array.isArray(data.errors) ? data.errors[0] : data.message;
            // console.log("uploadImage", err);
            error(formatMessage(err.response));
        } finally {
            dispatch(setLoading(false));
        }
    };

    const verifyProduct = async () => {
        try {
            if (inputValue.serialNumber && inputValue.productCode) {
                UIStore.setState({ isLoading: true });
                const res = await pumkinAPI.verifyProduct(
                    `?serialNumber=${inputValue.serialNumber}&skuCode=${inputValue.productCode}`
                );
                setDataVerify(res.data);
                if (res.data.statusCode === "200") {
                    setInputValue({ ...inputValue, productName: res.data.value?.productname });
                }
            } else {
                alert("Please enter serial number and product code");
            }
        } catch (err: any) {
            console.log("verifyProduct", err);
            setDataVerify({ statusCode: "500" });
            setInputValue({ ...inputValue, serialNumber: "", productCode: "" });
        } finally {
            UIStore.setState({ isLoading: false });
        }
    };

    const handleConfirm = async () => {
        await null;
        let check = false;
        let mss = "";
        try {
            UIStore.setState({ isLoading: true });
            dispatch(setLoading(true));
            setShowLoading(true);
            // if (isProcessing) {
            //     // If the button is already processing, do nothing
            //     return;
            // }
            // setIsProcessing(true);
            if (!inputValue.serialNumber) {
                check = true;
                mss = "Serial number is required";
            } else if (!inputValue.productCode) {
                check = true;
                mss = "Code is required";
            } else if (!inputValue.productName) {
                check = true;
                mss = "Product name is required";
            } else if (!inputValue.channel) {
                check = true;
                mss = "Channel is required";
            } else if (!inputValue.store) {
                check = true;
                mss = "Store is required";
            } else if (!inputValue.purchaseDate) {
                check = true;
                mss = "Purchase date is required";
            }
            if (receiptImg === "") {
                check = true;
                mss = t("page.upload_receipt.empty_error");
            }
            if (check) {
                warning(mss);
            } else {
                if (imgFile.size >= _10MB) {
                    error(t("validation.image.max_size"));
                    dispatch(setLoading(false));
                } else {
                    const formData = new FormData();
                    formData.append("file", imgFile);

                    let imgUrl = await uploadImage(formData);

                    if (imgUrl) {
                        let payload: IinputValue = {
                            warrantyImage: imgUrl,
                            ...inputValue,
                            condition: dataVerify?.value?.productcondition,
                            remark: dataVerify?.value?.productnote,
                            productImage: dataVerify?.value?.productimage,
                            warrantyDurationMonth: dataVerify?.value?.period * 1,
                            productModel: dataVerify?.value?.productmodel,
                        };
                        await pumkinAPI.registerWarranty(payload);
                        success(
                            t("page.upload_receipt.success_with_text", {
                                text: merchant?.superAdminTier?.uploadEvidenceDisplay || "",
                            })
                        );
                        setIsShowPopupDone(true);
                    }
                    UIStore.setState({ isLoading: false });
                }
            }
            console.log("check", check);
        } catch (err: any) {
            // const data = err.response.data;
            // const mess = Array.isArray(data.errors) ? data.errors[0] : data.message;
            error(formatMessage(err.response));
            // setIsProcessing(false);
        } finally {
            dispatch(setLoading(false));
            UIStore.setState({ isLoading: false });
        }
    };
    const calculateFadeColor = (color: string) => {
        const red = parseInt(color.substring(1, 3), 16);
        const green = parseInt(color.substring(3, 5), 16);
        const blue = parseInt(color.substring(5, 7), 16);
        const alpha = 0.08;
        return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
    };

    const resetStates = () => {
        setDetailTools(false);
    };

    return (
        <StyledReceiptPage
            themeColor={themes?.themeColor!}
            fadeColor={calculateFadeColor(themes?.themeColor!)}
            style={{ height: "calc(var(--vh, 1vh) * 100)" }}
        >
            <>
                <header>
                    <div className="back-arrow">
                        <ArrowLeftColor
                            color={themes?.themeColor}
                            onClick={() => history.goBack()}
                        />
                        {/* <span>{t("page.back")}</span> */}
                    </div>
                </header>
                <div className="step-logo">
                    {/* <div className="step">
                    <p>1</p>
                    <div>&nbsp;</div>
                    <p>2</p>
                </div> */}
                    <Skeleton loading={isLoading} active avatar title={false} paragraph={false}>
                        <div className="logo">
                            <img src={merchant?.themes?.logoSmallUrl} />
                        </div>
                    </Skeleton>
                </div>
                <div className="title-receipt">
                    <Skeleton
                        loading={isLoading}
                        active
                        title={{ width: 168 }}
                        paragraph={{ rows: 2, width: [268, 206] }}
                    >
                        <h1>ลงทะเบียนรับประกันออนไลน์</h1>
                        {/* <p>รับสิทธิ์ลุ้นโชคทันที</p>
                        <p>เครื่องมือไฟฟ้า 1 เครื่อง = 2 สิทธิ์</p> */}
                    </Skeleton>
                </div>
                <div className="layout-img-skeleton">
                    <Skeleton
                        loading={isLoading}
                        active
                        title={true}
                        paragraph={{ rows: 1, width: [100] }}
                    >
                        <input
                            //@ts-ignore
                            ref={inputRef}
                            type="file"
                            hidden
                            id="uploadImage"
                            onChange={changeImg}
                            accept="image/png, image/jpeg, image/jpg"
                        />
                        <div className="box-image">
                            {receiptImg === "" ? (
                                <div className="dont-have-img">
                                    <label className="camera-text" htmlFor="uploadImage">
                                        <ImageUploadIcon color={themes?.themeColor!} />
                                        <p>+ คลิกที่นี่ อัปโหลดรูปบัตรประกันสินค้า / ใบเสร็จ</p>
                                    </label>
                                </div>
                            ) : (
                                <div className="have-img">
                                    <label className="camera-text" htmlFor="uploadImage">
                                        <img src={receiptImg} />
                                    </label>
                                </div>
                            )}
                        </div>
                    </Skeleton>
                    <div className="btn-skeleton">
                        <Skeleton loading={isLoading} active title={false} paragraph={{ rows: 2 }}>
                            <Button
                                className="view-btn-type-2"
                                onClick={() => {
                                    setOpenShowPopup(true);
                                }}
                            >
                                ดูตัวอย่างบัตรประกันสินค้า / ใบเสร็จ
                            </Button>
                        </Skeleton>
                    </div>

                    {dataVerify?.statusCode !== "200" && (
                        <div className="verify-box">
                            <div>
                                <p className="custom-title-input">
                                    {"รหัสสินค้า"}
                                    <span style={{ color: "black" }}> * </span>
                                    <span onClick={() => setOpenCodePopup(true)}>
                                        <QuestionCircleOutlined />
                                    </span>
                                </p>
                                <Input
                                    placeholder={"กรอกรหัสสินค้า"}
                                    name="productCode"
                                    onChange={handleChange}
                                    value={inputValue.productCode}
                                    // value={ans.companyName}
                                />
                                {dataVerify?.statusCode === "500" && (
                                    <div className="text-error">
                                        ไม่พบรหัสสินค้า กรุณาระบุใหม่อีกครั้ง*
                                    </div>
                                )}
                            </div>
                            <div>
                                <p className="custom-title-input">
                                    {"เลขซีเรียล"}
                                    <span style={{ color: "black" }}> * </span>
                                    <span onClick={() => setOpenSNPopup(true)}>
                                        <QuestionCircleOutlined />
                                    </span>
                                </p>
                                <Input
                                    placeholder={"กรอกเลขซีเรียล"}
                                    name="serialNumber"
                                    onChange={handleChange}
                                    value={inputValue.serialNumber}
                                />
                                {dataVerify?.statusCode === "500" && (
                                    <div className="text-error">
                                        ไม่พบเลขซีเรียล กรุณาระบุใหม่อีกครั้ง*
                                    </div>
                                )}
                            </div>

                            <Button
                                className="verify-button"
                                onClick={() => {
                                    verifyProduct();
                                }}
                            >
                                ตรวจสอบการรับประกัน
                            </Button>
                        </div>
                    )}
                    {dataVerify?.statusCode === "200" && (
                        <div className="verified-box">
                            <div
                                className="top-card"
                                style={{
                                    backgroundColor:
                                        dataVerify?.value?.productwarranty === "Yes"
                                            ? "#26c2a4"
                                            : "#e74c3c",
                                }}
                            >
                                <span>
                                    {dataVerify?.value?.productwarranty === "Yes" ? (
                                        <IconCheck3 color={"#FFF"} />
                                    ) : null}
                                </span>
                                {dataVerify?.value?.productwarranty === "Yes"
                                    ? "เงื่อนไขการรับประกันสินค้า"
                                    : "สินค้าดังกล่าวไม่อยู่ในเงื่อนไขรับประกัน"}
                            </div>

                            <div
                                className="content-card"
                                style={{
                                    backgroundColor:
                                        dataVerify?.value?.productwarranty === "Yes"
                                            ? "rgba(38, 194, 164, 0.12)"
                                            : "#f5b7b1",
                                }}
                            >
                                <div>
                                    <img src={dataVerify?.value?.productimage} />
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div className="title">
                                        {dataVerify?.value?.productname || ""}
                                    </div>
                                    <div className="desc">
                                        รุ่น : {dataVerify?.value?.productmodel || ""}
                                    </div>
                                    <div className="desc">
                                        รหัสสินค้า : {dataVerify?.value?.productcode || ""}
                                    </div>
                                    <div className="desc">
                                        เลขซีเรียล : {dataVerify?.value?.productserialnumber || ""}
                                    </div>

                                    {/* <div className="desc-condition">
                                            เงื่อนไขการรับประกัน :{" "}
                                            {dataVerify?.value?.productcondition}
                                        </div> */}
                                    <div className="cancel">
                                        <div className="btn-condition">
                                            {dataVerify?.value?.productwarranty === "Yes" &&
                                                Array.isArray(
                                                    dataVerify?.value?.productcondition
                                                ) &&
                                                dataVerify?.value?.productcondition.length > 0 && (
                                                    <div
                                                        onClick={() =>
                                                            setSelectedDetail("conditions")
                                                        }
                                                    >
                                                        <span>
                                                            <img
                                                                src="../../images/ic-warning.svg"
                                                                alt=""
                                                            />
                                                        </span>
                                                        เงื่อนไขการรับประกัน
                                                    </div>
                                                )}
                                        </div>
                                        <div
                                            onClick={() => {
                                                setDataVerify(null);
                                                setInputValue({
                                                    ...inputValue,
                                                    serialNumber: "",
                                                    productCode: "",
                                                });
                                            }}
                                            className="btn-cancel"
                                        >
                                            {t("page.cancel")}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* <div>
                            <p className="custom-title-input">
                                {"ชื่อสินค้า"}
                                <span style={{ color: "black" }}> * </span>
                            </p>
                            <Input
                                placeholder={"กรอกชื่อสินค้า"}
                                name="productName"
                                onChange={handleChange}
                                value={inputValue.productName}
                            />
                        </div> */}
                    <div>
                        <p className="custom-title-input">
                            {"ซื้อจากช่องทางไหน"}
                            <span style={{ color: "black" }}> * </span>
                        </p>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    placeholder={"เลือกช่องทาง"}
                                    // value={ans.gender}
                                    onChange={(val: string) => {
                                        onChannelChange(val);
                                    }}
                                    className="channel-select"
                                    suffixIcon={<DownOutlined style={{ color: themeColor }} />}
                                >
                                    {channelList?.map((item: any, index: number) => (
                                        <Option value={item} key={index}>
                                            {item}
                                        </Option>
                                    ))}
                                </Select>
                            </Col>
                        </Row>
                    </div>
                    <div>
                        <p className="custom-title-input">
                            {inputValue.channel || "ชื่อห้างสรรสินค้า / ร้านตัวแทนจำหน่าย"}
                            <span style={{ color: "black" }}> * </span>
                        </p>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Select
                                    showSearch
                                    placeholder={"กรอกชื่อห้างสรรสินค้า / ร้านตัวแทนจำหน่าย"}
                                    value={inputValue.store}
                                    onChange={(val: string) =>
                                        setInputValue((prevState) => ({
                                            ...prevState,
                                            store: val,
                                        }))
                                    }
                                    className="channel-select"
                                    suffixIcon={<DownOutlined style={{ color: themeColor }} />}
                                >
                                    {storeList?.map((item: any, index: number) => (
                                        <Option
                                            value={`${item.custname} ${item.branch}`}
                                            key={index}
                                        >
                                            {`${item.custname} ${item.branch}`}
                                        </Option>
                                    ))}
                                </Select>
                            </Col>
                        </Row>
                    </div>
                    <div>
                        <p className="custom-title-input">
                            {"วันที่ซื้อสินค้า"}
                            <span style={{ color: "black" }}> * </span>
                        </p>
                        <DatePicker
                            className="date-picker"
                            suffixIcon={<CalendarOutlined style={{ color: themeColor }} />}
                            placeholder="เลือกวันที่ซื้อสินค้า"
                            onChange={onChangeDate}
                            disabledDate={(d) => !d || d.isAfter(new Date())}
                        />
                    </div>
                    <div>
                        <p className="custom-title-input">{"รหัสพนักงานขาย (ถ้ามี)"}</p>
                        <Input
                            placeholder={"กรอกรหัสพนักงานขาย"}
                            name="sellerId"
                            onChange={handleChange}
                            value={inputValue.sellerId}
                            // value={ans.companyName}
                        />
                    </div>
                    <div className="bottom-action">
                        <button
                            className="btn-cancel"
                            onClick={() => history.goBack()}
                            // disabled={isProcessing}
                        >
                            ยกเลิก
                        </button>
                        <button
                            className={
                                !dataVerify || dataVerify.value?.productwarranty === "No"
                                    ? "btn-confirm-disabled"
                                    : "btn-confirm"
                            }
                            onClick={handleConfirm}
                            disabled={!dataVerify || dataVerify.value?.productwarranty === "No"}
                        >
                            ยืนยัน{" "}
                            <span>
                                <SendIcon />
                            </span>
                        </button>
                    </div>
                    <br />

                    {openshowpopup && (
                        <StyledPopupRedeem themeColor={themes?.themeColor!}>
                            <div className="box-popupconfirm">
                                <div className="textTitle">
                                    ดูตัวอย่างบัตรรับประกันสินค้า / ใบเสร็จ
                                </div>
                                <div className="textDesc">ตำแหน่งการรับประกันสินค้า</div>
                                <img src={"../images/pumpkinWarranty.jpeg"} alt="" />
                                <button
                                    onClick={() => setOpenShowPopup(false)}
                                    className="btnClose"
                                >
                                    ปิด
                                </button>
                            </div>
                        </StyledPopupRedeem>
                    )}
                    {openCodePopup && (
                        <StyledPopupRedeem themeColor={themes?.themeColor!}>
                            <div className="box-popupconfirm">
                                <div className="textTitle">ดูตัวอย่างรหัสสินค้า</div>
                                <div className="textDesc">ตำแหน่งรหัสสินค้า</div>
                                <img src={"../images/productCode.jpg"} alt="" />
                                <button
                                    onClick={() => setOpenCodePopup(false)}
                                    className="btnClose"
                                >
                                    ปิด
                                </button>
                            </div>
                        </StyledPopupRedeem>
                    )}
                    {openSNPopup && (
                        <StyledPopupRedeem themeColor={themes?.themeColor!}>
                            <div className="box-popupconfirm">
                                <div className="textTitle">ดูตัวอย่างหมายเลขเครื่อง</div>
                                <div className="textDesc">ตำแหน่งหมายเลขเครื่อง</div>
                                <img src={"../images/serialNo.jpg"} alt="" />
                                <button onClick={() => setOpenSNPopup(false)} className="btnClose">
                                    ปิด
                                </button>
                            </div>
                        </StyledPopupRedeem>
                    )}

                    {selectedDetail && (
                        <StyledShowPopup themeColor={themes?.themeColor!}>
                            <div className="page-wrapper">
                                {/* <div className="back" onClick={() => setSelectedDetail(null)}>
                                    <BackIcon color={"#000"} />
                                </div> */}
                                <div className="close" onClick={() => setSelectedDetail(null)}>
                                    <IConClose width={16} />
                                </div>
                                <div className="content-layout">
                                    {dataVerify?.value?.period && (
                                        <>
                                            <h3>ระยะเวลารับประกัน</h3>
                                            <ul>
                                                <li>{dataVerify?.value?.period} เดือน</li>
                                            </ul>
                                        </>
                                    )}
                                    {Array.isArray(dataVerify?.value?.productcondition) && (
                                        <>
                                            <h3>เงื่อนไขการรับประกัน</h3>
                                            <ul>
                                                {Array.isArray(
                                                    dataVerify?.value?.productcondition
                                                ) &&
                                                    dataVerify?.value?.productcondition.map(
                                                        (item: any, index: number) => (
                                                            <li key={index}>{item}</li>
                                                        )
                                                    )}
                                            </ul>
                                        </>
                                    )}
                                    {Array.isArray(dataVerify?.value?.productnote) && (
                                        <>
                                            <h3>หมายเหตุรับประกัน</h3>
                                            <ul>
                                                {Array.isArray(dataVerify?.value?.productnote) &&
                                                    dataVerify?.value?.productnote.map(
                                                        (item: any, index: number) => (
                                                            <li key={index}>{item}</li>
                                                        )
                                                    )}
                                            </ul>
                                        </>
                                    )}
                                </div>
                            </div>
                        </StyledShowPopup>
                    )}
                    {isShowPopupDone && (
                        <PumpkinPopupDone
                            handleClose={() => {
                                setIsShowPopupDone(false);
                                history.push(PATH_WARRANTY_LIST);
                            }}
                        />
                    )}
                </div>
            </>
        </StyledReceiptPage>
    );
};

const StyledShowPopup = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    transition: 2s !important;
    animation: opacity 0.5s !important;
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    .page-wrapper {
        position: relative;
        width: 100%;
        min-height: 55%;
        background-color: #fff;
        border-top-left-radius: 14px;
        border-top-right-radius: 14px;
        .close {
            position: absolute;
            right: 18px;
            top: 18px;
            z-index: 1;
        }
        .back {
            position: absolute;
            left: 18px;
            top: 18px;
            z-index: 1;
        }
    }
    .content-layout {
        height: auto;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #fff;
        /* padding-top: 24px;
        padding-bottom: 24px; */
        padding: 48px 24px;
        min-height: 60%;
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .edit-sub-text {
            font-size: 14px;
            line-height: 17px;
            text-align: center;
            color: #f2a808;
            margin-bottom: 12px;
        }
        .img-detail-tools {
            width: 140px;
            height: 140px;
            border-radius: 100%;
            overflow: hidden;
            text-align: center;
            margin: 0 auto;
            position: relative;
            margin-top: -90px;
            background-color: #fff;
            margin-bottom: 25px;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
        .title-details-tools {
            h2 {
                font-size: 18px;
                font-weight: 600;
                line-height: 21px;
                color: #000;
                margin-bottom: 16px;
                text-align: center;
            }
        }
    }
`;

const StyledLoading = styled.div`
    display: flex;
    width: 100%;
    height: 100dvh;
    background-color: rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    background-image: url(../../images/img-loading.gif);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 50px;
`;

const StyledShowImg = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    flex-direction: column;
    .control-show-img {
        img {
            width: 100%;
        }
    }
    .close-popupinvite {
        position: relative;
        margin-top: 30px;
        z-index: 5;
        img {
            width: 32px;
        }
    }
`;

const StyledPopupRedeem = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    left: 0;
    .box-popupconfirm {
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 20px;
        .textTitle {
            color: ${(p) => p.themeColor};
            text-align: center;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
        .textDesc {
            color: var(--Text-3, #96979c);
            text-align: center;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
        }
        .btnClose {
            display: flex;
            height: 45px;
            padding: 14.5px 32px;
            justify-content: center;
            align-items: center;
            gap: 8px;
            align-self: stretch;
            border-radius: 14px;
            background: ${(p) => p.themeColor};
            margin-top: 20px;
            color: #fff;
            border: none;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
        img {
            width: 100%;
        }
        .box-close {
            position: absolute;
            top: -14px;
            right: -14px;
            img {
                width: 30px;
                height: 30px;
            }
        }
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
    }
    .close {
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
        transform: rotate(0deg);
        transition: 0.6s;
        &:hover {
            transform: rotate(90deg);
        }
    }
    .title {
        display: flex;
        align-items: center;
        .image {
            width: 28px;
            margin-right: 8px;
        }
        .member {
            font-style: normal;
            color: ${(p) => p.theme.colors.color};
        }
    }
`;

const StyledReceiptPage = styled.div<{ themeColor: string; fadeColor: string }>`
    // height: 100dvh;
    padding: 20px;
    position: relative;
    background-color: #fff;
    position: relative;

    .layout-img-skeleton {
        .ant-skeleton {
            .ant-skeleton-title {
                height: 250px;
                border-radius: 16px;
                width: 100% !important;
            }
            .ant-skeleton-paragraph {
                li {
                    height: 10px;
                    border-radius: 16px;
                    margin: 0 auto;
                }
            }
        }
        .btn-skeleton {
            .ant-skeleton {
                .ant-skeleton-paragraph {
                    li {
                        height: 52px;
                        border-radius: 16px;
                        width: 100% !important;
                        margin-bottom: 15px;
                    }
                }
            }
        }
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        display: flex;
        align-items: center;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
    .step-logo {
        display: flex;
        justify-content: center;
        .ant-skeleton {
            .ant-skeleton-header {
                text-align: center;
                padding-right: 0;
                span {
                    width: 105px;
                    height: 105px;
                    margin: 0 auto;
                }
            }
        }
        .step {
            display: flex;
            p {
                margin: none;
                background-color: ${(p) => p.themeColor};
                padding: 2px 10px 4px 10px;
                color: ${(p) => p.theme.colors.white};
                border-radius: 100px;
                font-size: 16px;
            }
            div {
                border-top: 3px solid ${(p) => p.themeColor};
                height: 3px;
                width: 20px;
                margin-top: 14px;
            }
        }
        .logo {
            width: 75px;
            height: 75px;
            border-radius: 100%;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
    .info {
        text-align: right;
        margin-bottom: 5px;
        img {
            width: 18px;
        }
    }
    .seller-input-section {
        input {
            border: 1px solid ${(p) => p.themeColor};
            border-radius: 15px;
            height: 68px !important;
            color: black;
        }
        .ant-input-suffix {
            z-index: 0;
        }
        .input-btn {
            color: #ffffff;
            background-color: ${(p) => p.themeColor};
            border-radius: 12px;
            height: 43px;
        }
    }
    .ex-receipt {
        font-size: 12px;
        color: ${(p) => p.themeColor};
        text-decoration: underline;
        text-align: center;
        margin-bottom: 16px;
    }
    .title-receipt {
        margin-bottom: 16px;
        text-align: center;
        .ant-skeleton {
            .ant-skeleton-content {
                display: flex;
                flex-direction: column;
                align-items: center;
                .ant-skeleton-title {
                    margin-top: 15px;
                    margin-bottom: 12px;
                    height: 10px;
                    border-radius: 16px;
                }
                .ant-skeleton-paragraph {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-top: 15px;
                    li {
                        height: 10px;
                        border-radius: 16px;
                    }
                }
            }
        }
        h1 {
            font-size: 28px;
            font-weight: 500;
            color: #01040d;
            margin: 8px 0;
        }
        p {
            color: #96979c;
            font-size: 16px;
            line-height: 19px;
            font-weight: 400;
        }
    }

    .box-image {
        margin: 15px 0px 16px;
        background-color: ${(p) => p.fadeColor};
        opacity: 0.5;
        border-radius: 20px;
        text-align: center;
        border: 2px dashed ${(p) => p.themeColor};
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px 0;
        min-height: 150px;
        .dont-have-img {
            margin: 40px 20px;
            cursor: pointer;
        }
        svg {
            margin-bottom: 10px;
        }
        .have-img {
            margin: 8px;
            img {
                max-width: 100%;
                max-height: 200px;
                border-radius: 16px;
            }
        }
        .color-span {
            color: ${(p) => p.themeColor};
        }
    }
    .view-btn {
        width: 100%;
        border: 1px solid ${(p) => p.themeColor};
        border-radius: 50px;
        height: 48px;
        color: #fff;
        background-color: ${(p) => p.themeColor};
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            margin-right: 5px;
        }
    }
    .view-btn-type-2 {
        width: 100%;
        border: 1px solid ${(p) => p.themeColor};
        border-radius: 14px;
        height: 48px;
        color: ${(p) => p.themeColor};
        background-color: ${(p) => p.theme.colors.card};
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            margin-right: 5px;
        }
    }
    .input-title {
        margin-bottom: 5px;
        margin-top: 40px;
        color: ${(p) => p.themeColor};
    }
    .input-receipt {
        height: 58px;
        padding-left: 20px;
        border: 1px solid ${(p) => p.themeColor}70;
        border-radius: 10px;
        outline: none;
    }
    .input-receipt:focus {
        outline: none;
        box-shadow: none;
    }
    .scan-qr {
        text-align: center;
        width: calc(100% + 40px);
        margin-left: -20px;
        margin-top: 20px;
        section {
        }
    }

    .btn-section {
        width: 100%;
        position: relative;
        padding: 15px 0;
        .btn {
            width: 100%;
            height: 48px;
            border-radius: 50px;
            font-size: 16px;
            font-weight: 600;
            box-shadow: none;
            span {
                font-weight: 600;
            }
        }
        .back {
            border: 1px solid ${(p) => p.themeColor};
            color: black;
        }
        .confirm {
            border: 1px solid ${(p) => p.themeColor};
            color: white;
            background-color: ${(p) => p.themeColor};
        }
    }
    .example-modal {
        position: fixed;
        bottom: 0px;
        width: 480px;
        max-width: 100vw;
        background-color: pink;
        height: 50vh;
        border-radius: 25px 25px 0 0;
    }
    .ant-input {
        border-radius: 5px;
    }
    .verify-box {
        padding: 15px;
        background-color: #f4f6fa;
        margin: 15px 5px 5px 5px;
        border-radius: 12px;

        text-error {
            color: #e53223;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            margin-top: 5px;
        }

        .verify-button {
            display: flex;
            padding: 14.5px 32px;
            border: none;
            justify-content: center;
            align-items: center;
            gap: 8px;
            align-self: stretch;
            width: 100%;
            height: 45px;
            border-radius: 14px;
            background: ${(p) => p.themeColor};
            margin-top: 15px;
            color: var(--Text-6, #fff);
            text-align: center;
            font-size: 13px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
    }
    .verified-box {
        margin: 15px 5px 5px 5px;
        .top-card {
            display: flex;
            padding: 4px 8px;
            justify-content: center;
            align-items: center;
            gap: 4px;
            align-self: stretch;
            background: #26c2a4;
            color: #fff;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            border-radius: 12px 12px 0 0;
        }
        .content-card {
            display: flex;
            padding: 14px;
            justify-content: flex-start;
            align-items: flex-start;
            gap: 12px;
            align-self: stretch;
            background: rgba(38, 194, 164, 0.12);
            border-radius: 0 0 12px 12px;
            position: relative;
            padding-bottom: 30px;
            img {
                width: 64px;
                height: 64px;
                border-radius: 12px;
                object-fit: cover;
            }
            .title {
                color: #000;
                font-size: 14px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }
            .desc {
                color: #525257;
                font-size: 11px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
            .desc-condition {
                color: #525257;
                font-size: 11px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
            .cancel {
                display: flex;
                width: calc(100% - 32px);
                -webkit-box-pack: justify;
                justify-content: space-between;
                -webkit-box-align: center;
                align-items: center;
                position: absolute;
                left: 16px;
                bottom: 16px;
                margin: 0 auto;
                .btn-condition {
                    cursor: pointer;
                    font-size: 11px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                    text-decoration-line: underline;
                    span {
                        margin-right: 5px;
                        position: relative;
                        top: 3px;
                        img {
                            width: 14px;
                            height: 14px;
                        }
                    }
                }
                .btn-cancel {
                    cursor: pointer;
                    color: #9b9b9b;
                    font-size: 11px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                    text-decoration-line: underline;
                }
            }
        }
    }
    .custom-title-input {
        margin: 12px 0 8px 0;
        color: #919191;
        font-size: 16px;
        font-weight: 500;
    }
    .ant-select {
        width: 100%;
        border-radius: 15px;
    }
    .channel-select {
        width: 100%;
        border-radius: 15px;
    }
    .date-picker {
        width: 100%;
        height: 45px;
    }
    .bottom-action {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .btn-cancel {
            display: flex;
            width: 109px;
            padding: 14.5px 32px;
            justify-content: center;
            align-items: center;
            gap: 8px;
            flex-shrink: 0;
            border-radius: 14px;
            border: 0.8px solid #231f20;
            background: #fff;
            margin-right: 20px;
            height: 45px;
            font-size: 13px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            color: #000000;
            &:active {
                opacity: 0.8;
            }
        }
        .btn-confirm {
            display: flex;
            padding: 14.5px 32px;
            justify-content: center;
            align-items: center;
            gap: 4px;
            flex: 1 0 0;
            background-color: ${(p) => p.themeColor};
            border-radius: 14px;
            color: #fff;
            height: 45px;
            border: none;
            font-size: 13px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            &:active {
                opacity: 0.8;
            }
        }
        .btn-confirm-disabled {
            display: flex;
            padding: 14.5px 32px;
            justify-content: center;
            align-items: center;
            gap: 4px;
            flex: 1 0 0;
            background-color: #e1e1e1;
            border-radius: 14px;
            color: #fff;
            height: 45px;
            border: none;
            font-size: 13px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            &:active {
                opacity: 0.8;
            }
        }
    }
`;
